<template>
	<section class="app-main" style="min-height: 100%">
    <!-- <Levelbar></Levelbar> -->
		<transition name="fade" mode="out-in">
			<router-view :key="key"></router-view>
		</transition>
	</section>
</template>

<script>
import Levelbar from "./Levelbar";
	export default {
  components: {
    Levelbar,
  },
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  }
}
</script>




// WEBPACK FOOTER //
// AppMain.vue?10c0b1b2